// extracted by mini-css-extract-plugin
export default {"BonusLabel":"BonusLabel_BonusLabel__VEc3i"};